export type BillingCycle = 'monthly' | 'annual';

export interface Plan {
  id: 'free' | 'pro' | 'max';
  name: string;
  tagline: string;
  priceMonthly: number;
  priceAnnual: number;
  /** Show as "Most popular" / "Best value" / etc */
  badge?: string;
  highlight?: boolean;
  cta: { label: string; to: string };
  features: string[];
}

export const PLANS: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    tagline: 'Everything you need to tune your own car. Forever.',
    priceMonthly: 0,
    priceAnnual: 0,
    cta: { label: 'Download Free', to: '/download' },
    features: [
      'Full map editor (2D + 3D)',
      'Deterministic Tier 1 safety',
      'Vehicle profile & mod catalog',
      '3 base maps included',
      'Local-only datalog viewer',
      'Community read access',
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    tagline: 'For tuners who want the AI advisor and unlimited community.',
    priceMonthly: 12.99,
    priceAnnual: 99,
    badge: 'Most popular',
    highlight: true,
    cta: { label: 'Subscribe', to: '/download?plan=pro' },
    features: [
      'Everything in Free',
      'Tier 3 AI advisor (cell + tune)',
      'Datalog analyzer (cloud sync)',
      'Unlimited community uploads',
      'Tune health dashboard',
      'Revision history + diffs',
      'Priority email support',
    ],
  },
  {
    id: 'max',
    name: 'Max',
    tagline: 'For shops & power users. Pro plus per-VIN licensing.',
    priceMonthly: 39,
    priceAnnual: 390,
    cta: { label: 'Contact sales', to: '/about#contact' },
    features: [
      'Everything in Pro',
      '5 VIN licenses included',
      'Shared shop workspace',
      'OBD-II live tuning',
      'Audit log export (PDF + CSV)',
      'SLA & dedicated support',
      'Early access to new features',
    ],
  },
];
